import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "./index.scss";
import logoSrc from "../../../resources/images/svg/martley_full_logo.svg";
import { Socmed } from "..";
import ScrollUp from "components/_ui/ScrollUp/ScrollUp";

export default function Footer() {
  useEffect(() => {
    AOS.init({ duration: 1200, mirror: true });
  }, []);

  return (
    <footer className="footer">
      {/* ─── MAIN FRAME ───────────────────────────── */}
      <div className="footer__frame">
        {/* 1) Brand Logo */}
        <div className="footer__col footer__col--logo">
          <img
            src={logoSrc}
            alt="Martley Strategy logo"
            className="footer__logo"
          />
        </div>

        {/* 2) Social Icons + Email */}
        <div className="footer__col footer__col--social">
          <div className="footer__social-icons">
            <Socmed />
          </div>
          <p className="footer__email">hello@martleystrategy.com</p>
        </div>

        {/* 3) Text Block */}
        <div className="footer__col footer__col--info">
          <p className="footer__info-text">
            Martley Strategy (formerly Martley Business Design) is a branding
            and strategy consultancy that helps businesses create distinct,
            impactful, and growth-driven brands.
          </p>
          <p className="footer__info-highlight">
            Branding, strategy &amp; digital solutions for growth-driven
            businesses.
          </p>
        </div>
      </div>

      {/* ─── 4) Legal links + Copyright ───────────────────── */}
      <div className="footer__bottom">
        {/* Legal links */}
        <nav className="footer__legal" aria-label="Legal links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <span className="sep" aria-hidden="true">|</span>
          <Link to="/cookie-policy">Cookie Policy</Link>
          <span className="sep" aria-hidden="true">|</span>
          <button
            type="button"
            className="footer__cookie-btn"
            onClick={() => window.CookieConsent && window.CookieConsent.showPreferences()}
          >
            Cookie Preferences
          </button>
        </nav>

        {/* Copyright */}
        <p className="footer__copyright">
          © Martley Strategy™. All Rights Reserved. The Martley Strategy™ name
          and logo are trademarks of Martley Strategy. Unauthorized use,
          reproduction, or distribution is strictly prohibited.
        </p>

        <ScrollUp className="footer__bottom-scroll" />
      </div>
    </footer>
  );
}